/** Интернет-эквайринги */
export enum InternetAcquiringEnum {
  /** ЮМани, она же яндекс.касса */
  YooMoney = 0,
  /** Пейлер */
  Payler = 1,
  /** Ассист */
  Assist = 2,
  /** Сплит, yandex.pay */
  YandexPay = 3
}